import moment from 'moment'
import { Actions, Lookup } from '~/utils'
import { messageErrorFormikLog } from '~/utils/message'
import { LogAPI } from '../../../../api'

const PayloadEnumServiceRequestModel = {
  action: Actions.GET_ALL_MASTER_ENUM,
  query: {
    Skip: 0,
    Take: 1000,
    Orders: [],
    Filters: [
      {
        type: 'text',
        field: 'type',
        value: 'SR_Model'
      }
    ],
  }
}

const PayloadEnumPriorityRequest = {
  action: Actions.GET_ALL_MASTER_ENUM,
  query: {
    Skip: 0,
    Take: 1000,
    Orders: [],
    Filters: [
      {
        type: 'text',
        field: 'type',
        value: 'priority'
      }
    ],
  }
}

const PayloadEnumFileSize = {
  action: Actions.GET_ALL_MASTER_ENUM,
  query: {
    Skip: 0,
    Take: 1000,
    Orders: [],
    Filters: [
      {
        type: 'text',
        field: 'type',
        value: 'file_size'
      }
    ],
  }
}

const PayloadEnumFileType = {
  action: Actions.GET_ALL_MASTER_ENUM,
  query: {
    Skip: 0,
    Take: 1000,
    Orders: [],
    Filters: [
      {
        type: 'text',
        field: 'type',
        value: 'file_type'
      }
    ],
  }
}

const FormInitialValues = {
  sr_no: '',
  remarks: '',
  location: '',
  location_id: '',
  client_code: '',
  sr_model_code: '',
  priority_code: '',
  estimation_start_date: '',
  estimation_finish_date: '',
}

const HandleInsertLog = async (form, type, msg) => {
  const userInfo = JSON.parse(localStorage.getItem('user_info'))
  const detail =
    Object.entries(form.touched).length > 0
      ? messageErrorFormikLog(form.errors)
      : Lookup.LOG_MESSAGE.NO_INPUT

  const actionMap = {
    draft: Lookup.LOG_ACTION.SAVE_DRAFT,
    update: Lookup.LOG_ACTION.UPDATE,
    submit: Lookup.LOG_ACTION.ADD,
  }

  const payload = {
    to: '',
    from: '',
    login: userInfo.User.Email,
    action: actionMap[type] || null,
    module: Lookup.LOG_MODULE.VESSEL_FORECAST,
    detail: msg !== '' ? msg : detail,
    logtype: Lookup.LOG_TYPE.SYSTEM_LOG,
    timestamp: moment().toISOString(),
    submodule: Lookup.LOG_SUB_MODULE.SERVICE_REQUEST,
    errorlevel: Lookup.LOG_ERROR_LEVEL.ERROR,
    db_destination: 'SR MAIN',
    refno: form.values.sr_no || 'SRXXXXXXXXXX',
  }

  if (
    (Object.entries(form.touched).length === 0) || //submit w/o touch field
    (Object.entries(form.errors).length > 0) // submit after touch field
  ) {
    const { data } = await LogAPI.PostDataLog(payload)
    if (data && data.result) return data.result
  } else {
    return false
  }
}

export default {
  HandleInsertLog,
  FormInitialValues,
  PayloadEnumFileSize,
  PayloadEnumFileType,
  PayloadEnumPriorityRequest,
  PayloadEnumServiceRequestModel,
}